module.exports = __webpack_public_path__ + "static/media/LeagueSpartan-Regular.a81ff45e.ttf";